/**
 * Join URL paths
 * @param {string[]} args
 * @returns {string}
 */
export function combineURL(...args: string[]): string {
    return args
        .map((s) => s.replace(/\/+$/, "")) // Fallback for URLs that has trailing slash
        .join("/");
}

/**
 * Gets the Uri pathname as an array
 * `/TagBrowser` is always omitted
 * 
 * (e.g. /TagBrowser/Wodo/Home as [
 *   "Wodo",
 *   "Home"
 * ])
 * 
 * Usage:
 * 
 * ```ts
 * const [ controller, action, id ] = getUriArray();
 * console.log(`This is the controller: ${controller}`);
 * console.log(`This is the action: ${action}`);
 * console.log(`This is the id of the element: ${id}`);
 * ```
 */
export function getUriArray(): string[] {
    return location.pathname.substring(1) // Gets the /TagBrowser/blah/ bit
        .split("/") // Split Uri into array
        .splice(1); // Remove `TagBrowser` bit
}
